const defaultDomain = process.env.VUE_APP_COOKIE_DEFAULT_DOMAIN;

export function removeAllCookie(sDomain = defaultDomain, sPath = "/") {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(
        /=.*/,
        `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;${
          sPath ? " path=" + sPath : ""
        };${sDomain ? " domain=" + sDomain : ""}`
      );
  });
}
